const Access = () => import('@/views/main/promotion/access/Access.vue')
export default {
  path: '/main/promotion/access',
  name: 'Access',
  component: Access,
  children: []
}
